import TrendsMenuGetters from "./TrendAssetsSelectorGetters";
import TrendMenuActions from "./TrendAssetsSelectorActions";
import TrendMenuMutations from "./TrendAssetsSelectorMutations";
import TrendAssetsSelectorService from "@/pages/common/trend/service/TrendAssetsSelectorService";

const state = TrendAssetsSelectorService.EmptyAssetSelectorStateFactory();

const { getters } = TrendsMenuGetters;

const { actions } = TrendMenuActions;

const { mutations } = TrendMenuMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations,
};